import { KeyboardEvent } from "react";

// Div and span "buttons" reach the keyboard through tabIndex, but only a real
// button turns Enter and Space into a click.
export const activateOnKey =
  (onActivate?: () => void) => (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onActivate?.();
    }
  };
